import { format, parseISO, sub } from 'date-fns';
import { ValueOf } from 'type-fest';
import { TEAM_CREATION_RANGE_OPTIONS } from './constants';

export const formatCountStatisticsDateParams = (date: string | Date) => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, 'yyyy-MM-dd');
};

export const calculateCountStatisticsDateParamsFromOption = (
  option: ValueOf<typeof TEAM_CREATION_RANGE_OPTIONS>,
) => {
  let lowerBound: undefined | string = undefined;
  let upperBound: undefined | string = formatCountStatisticsDateParams(new Date());

  switch (option) {
    case TEAM_CREATION_RANGE_OPTIONS.ALL_TEAMS: {
      upperBound = undefined;
      break;
    }
    case TEAM_CREATION_RANGE_OPTIONS.LAST_WEEK:
      lowerBound = formatCountStatisticsDateParams(sub(new Date(), { weeks: 1 }));
      break;
    case TEAM_CREATION_RANGE_OPTIONS.LAST_MONTH:
      lowerBound = formatCountStatisticsDateParams(sub(new Date(), { months: 1 }));
      break;
    case TEAM_CREATION_RANGE_OPTIONS.LAST_QUARTER:
      lowerBound = formatCountStatisticsDateParams(sub(new Date(), { months: 3 }));
      break;
  }

  return { lowerBound, upperBound };
};
